import React, { FC } from 'react';
import { FieldErrors } from 'react-hook-form';
import { FormControl } from '@fiverr-private/orca';
import { Textarea } from '@fiverr-private/forms';
import { translate as t } from '@fiverr-private/i18n-react';
import { Text } from '@fiverr-private/typography';
import { T_FORM_KEY } from '../../utils';
import { SimpleFieldComponentProps, WorkExperienceFormType } from '../../shared/types';

import { negativeMarginTop6 } from '../../shared/styles.ve.css';

interface DescriptionFieldProps extends SimpleFieldComponentProps {
    description?: string;
    errors?: FieldErrors<WorkExperienceFormType>;
}

const DescriptionField: FC<DescriptionFieldProps> = ({ register, defaultValues, description, errors }) => (
    <FormControl label={t(`${T_FORM_KEY}.fields.description.label`)} id="description" isError={!!errors?.description}>
        <Textarea
            maxLength={2000}
            rows={5}
            showCounter
            placeholder={t(`${T_FORM_KEY}.fields.description.placeholder`)}
            defaultValue={defaultValues?.description}
            isError={!!errors?.description}
            {...register('description', {
                required: {
                    value: true,
                    message: t(`${T_FORM_KEY}.fields.description.required_error`),
                },
            })}
        >
            {description}
        </Textarea>
        <Text color="validationError" hidden={!errors?.description} className={negativeMarginTop6}>
            {errors?.description?.message}
        </Text>
    </FormControl>
);

export default DescriptionField;
